<template>
  <div class="redirect-container">
    <div class="content">
      <div class="logo">
        <img src="https://res.wx.qq.com/a/wx_fed/assets/res/NTI4MWU5.ico" alt="微信图标">
      </div>
      <h1>正在打开“问鼎知肤”小程序</h1>
      <div class="loading" v-if="!showButton">
        <div class="spinner"></div>
      </div>
      <p class="tips" v-if="showButton">{{ tips }}</p>
      <button 
        v-if="showButton" 
        class="open-btn" 
        @click="openMiniProgram">
        立即打开
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WxRedirect',
  data() {
    return {
      schemeUrl: '', // 小程序的url
      taskId: '', // 
      extraData: {}, // 小程序需要的额外参数
      showButton: false, // 是否显示按钮
      tips: '点击下方按钮打开小程序', // 提示文本
      isAndroid: false, // 是否是Android设备
      isIOS: false, // 是否是iOS设备
      timer: null, // 定时器
    };
  },
  created() {
    // 检测设备类型
    this.detectDevice();
    
    // 解析URL参数
    // this.parseUrlParams();
    this.schemeUrl = this.parsehURL('schemeUrl');
    
    // 自动尝试打开小程序
    this.autoOpenMiniProgram();
  },
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    // 检测设备类型
    detectDevice() {
      const ua = navigator.userAgent.toLowerCase();
      this.isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
      this.isIOS = !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/);
      console.log('In WxRedirect, isAndroid:',this.isAndroid);
    },
    parsehURL(keyword){
      const url = window.location.href;
      const searchStr = url.split('?')[1];
      const params = searchStr.split('&');
      for(let item of params){
        let param = item.split('=');
        if(param[0] === keyword){
          console.log("parse", keyword, ', value: ', param[1]);
          return param[1]
        } 
      }
      return null
    },
    // 解析URL参数
    parseUrlParams() {
      const query = window.location.search.substring(1);
      const vars = query.split('&');
      console.log("In WxRedirect, parseUrlParams:",vars);
      console.log(encodeURIComponent("weixin://dl/business/?t=pr0F9YiBCdd"));
      
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (pair[0] === 'schemeUrl') {
          this.schemeUrl = decodeURIComponent(pair[1]);
        } else if (pair[0] === 'taskId') {
          this.taskId = decodeURIComponent(pair[1]);
        } 
      }
    },
    
    // 自动尝试打开小程序
    autoOpenMiniProgram() {
      if (this.isIOS) {
        // iOS设备可以直接尝试打开
        this.openMiniProgram();
        
        // 3秒后如果还在当前页面，显示按钮
        this.timer = setTimeout(() => {
          this.showButton = true;
          this.tips = '如果没有自动跳转，请点击下方按钮';
        }, 3000);
      } else {
        // Android设备直接显示按钮
        this.showButton = true;
        this.tips = 'Android设备需要点击按钮才能打开小程序';
      }
    },
    
    // 打开微信小程序
    openMiniProgram() {
      // 构建URL Scheme
      let schemeUrl = decodeURIComponent(this.schemeUrl);  // "weixin://dl/business/?t=pr0F9YiBCdd"
      console.log("In openMiniProgram, schemeUrl:",schemeUrl)
      
      // // 添加路径
      // if (this.path) {
      //   schemeUrl += `${this.path}?`;
      // }
      
      // // 添加额外参数
      // const params = [];
      // for (const key in this.extraData) {
      //   if (Object.prototype.hasOwnProperty.call(this.extraData, key)) {
      //     params.push(`${key}=${encodeURIComponent(this.extraData[key])}`);
      //   }
      // }
      
      // if (params.length > 0) {
      //   schemeUrl += params.join('&');
      // }
      
      // 尝试打开小程序
      window.location.href = schemeUrl;
      
      // 如果是Android设备，提供额外的引导
      // if (this.isAndroid) {
      //   this.tips = '如果未跳转到微信，请确保您已安装最新版微信';
        
      //   // 也可以考虑使用微信开放标签，但需要在微信环境中使用
      //   // 这里仅作为示例，实际使用需要按照微信官方文档配置
      //   if (window.WeixinJSBridge) {
      //     window.WeixinJSBridge.invoke('launchApplication', {
      //       appID: this.appId,
      //       parameter: JSON.stringify({
      //         path: this.path,
      //         query: this.extraData
      //       })
      //     }, function(res) {
      //       console.log('launchApplication response:', res);
      //     });
      //   }
      // }
    }
  }
};
</script>

<style scoped>
.redirect-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f8f8f8;
  padding: 0 20px;
  box-sizing: border-box;
}

.content {
  max-width: 500px;
  width: 100%;
  text-align: center;
  background-color: #fff;
  border-radius: 12px;
  padding: 30px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.logo {
  margin-bottom: 20px;
}

.logo img {
  width: 60px;
  height: 60px;
}

h1 {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 500;
}

.loading {
  display: flex;
  justify-content: center;
  margin: 30px 0;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #07C160;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.tips {
  font-size: 14px;
  color: #999;
  margin: 20px 0;
}

.open-btn {
  background-color: #07C160;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 80%;
  max-width: 300px;
}

.open-btn:hover {
  background-color: #06AD56;
}

.open-btn:active {
  background-color: #069C4F;
}
</style>